import * as THREE from 'three';
import { gsap } from 'gsap';
import * as Shader from "./Shader.js";

const instance = {
  camera: null,
  scene: null,
  renderer: null,
  uniforms: null,
  clock: null,
  animationId: null,
  mesh: null,
};

const canvas = document.getElementById('js-effect');
const entryBtn = document.getElementById('js-entry');
const overlay = document.getElementById('js-overlay');
const title = document.getElementById('js-title');
const content = document.getElementById('js-content');

const init = () => {
  document.documentElement.style.overflow = 'hidden';
  const width = window.innerWidth;
  const height = window.innerHeight;

  // Scene
  instance.scene = new THREE.Scene();

  // Camera
  instance.camera = new THREE.OrthographicCamera(
    -width / 2,
    width / 2,
    height / 2,
    -height / 2,
    0.1,
    10
  );
  instance.camera.position.z = 1;

  // Renderer
  instance.renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true });
  instance.renderer.setSize(width, height);
  instance.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

  // Uniforms
  instance.uniforms = {
    uTime: { value: 0 },
    uProgress: { value: 0.0 },
    uResolution: { value: new THREE.Vector2(width, height) },
  };

  // Material
  const material = new THREE.ShaderMaterial({
    vertexShader: Shader.vertex,
    fragmentShader: Shader.fragment,
    uniforms: instance.uniforms,
    transparent: true,
  });

  // Geometry & Mesh
  const geometry = new THREE.PlaneGeometry(width, height);
  instance.mesh = new THREE.Mesh(geometry, material);
  instance.scene.add(instance.mesh);

  // Clock
  instance.clock = new THREE.Clock(false);

  // Resize event
  window.addEventListener('resize', resize);

  // Entry button event
  entryBtn.addEventListener('click', onClickEntry);

  // Start animation loop
  animation();
};

const resize = () => {
  const w = window.innerWidth;
  const h = window.innerHeight;

  instance.camera.left = -w / 2;
  instance.camera.right = w / 2;
  instance.camera.top = h / 2;
  instance.camera.bottom = -h / 2;
  instance.camera.updateProjectionMatrix();

  instance.renderer.setSize(w, h);
  instance.uniforms.uResolution.value.set(w, h);

  instance.mesh.geometry.dispose();
  instance.mesh.geometry = new THREE.PlaneGeometry(w, h);
};

const animation = () => {
  instance.animationId = requestAnimationFrame(animation);
  render();
};

const render = () => {
  instance.uniforms.uTime.value = instance.clock.getElapsedTime();
  instance.renderer.render(instance.scene, instance.camera);
};

const onClickEntry = () => {
  entryBtn.disabled = true;
  instance.clock.start();

  const speed = 3;

  gsap.timeline()
    .to(title, {
      autoAlpha: 0,
      duration: 0.5,
      onStart: () => {
        content.style.visibility = 'visible';
      }
    })
    .to(instance.uniforms.uProgress, {
      value: 1,
      duration: speed,
      ease: 'power1.in',
      onComplete: () => {
        cancelAnimationFrame(instance.animationId);
        instance.animationId = null;

        instance.renderer.domElement.style.display = 'none';
        overlay.style.display = 'none';
        document.documentElement.style.overflow = '';
      }
    }, "-=0.5");
};

export {
  init,
  resize,
  animation,
  render
};
